import React from 'react';
import { TicketsPage } from '../components/tickets';

const Tickets: React.FC = () => {
  return <TicketsPage />;
};

export default Tickets;
